import React from 'react';
import { Alert } from '@metarouter-private/mr-mui';

const EXTERNAL_ALERT_TEXT =
  'Consent enforcement will be managed outside of this pipeline. MetaRouter will not filter events for this integration based on consent categories.';

export default function ConsentModeExternalAlert() {
  return <Alert severity="warning">{EXTERNAL_ALERT_TEXT}</Alert>;
}
